
import React from 'react';
import { theme } from '../../theme/theme';
import { Paper,Stack,Grid,FormControlLabel,Checkbox,CircularProgress,Typography,Button,Dialog,DialogTitle,DialogActions,DialogContent,FormControl,InputLabel,Select,MenuItem,TextField,IconButton,Backdrop } from '@mui/material';
import {Box} from '@mui/system';
import RemoteFileTree from './RemoteFileTree';
import SoftwareManagementService from './apiSoftwareManagement';
import {RemoteFileTreeType, WorkspaceType} from './workspace'
import { ReactComponent as DragDropIcon } from '../../assets/CloudFillIcon.svg';
import { ReactComponent as CloseButtonIcon } from '../../assets/CloseXIcon.svg';
import { ReactComponent as GogoLogoIcon } from '../../assets/GogoLogoIcon.svg'
import ErrorModal from "../../features/error/ErrorModal";
import { apiErrorSlice } from "../../features/error/apiError"
import { useDispatch } from "react-redux";
import './SoftwareManagementStyle.css'



const SoftwareManagement = (props) => {    
    const [workspace, setWorkspace] = React.useState(null);
    const [serverTree, setServerTree] = React.useState(null);
    const [openUploadDialog, setOpenUploadDialog] = React.useState(false);
    const [uploadingFile, setUploadingFile] = React.useState(false);
    const [publishingWorkspace, setPublishingWorkspace] = React.useState(false);
    const [copyingFiles,setCopyingFiles] = React.useState(false);
    const [openTreeDialog, setOpenTreeDialog] = React.useState(false);
    const [dropDownTargetType, setDropDownTargetType] = React.useState("");
    const [dropDownTargets, setDropDownTargets] = React.useState([]);
    const [treeNode, setTreeNode] = React.useState({id:null,name:null,allowAll:false,type:""});
    const [serialNumbers, setSerialNumbers] = React.useState([])
    const [serialFilter, setSerialFilter] = React.useState("")

    const dispatch = useDispatch();

    React.useEffect(() => {      
      fetchData();
    }, []);

    const fetchData = async () => {
      const data = await SoftwareManagementService.getSoftwareFileTree()     
      setServerTree(data);

      if(data.error != null) {
        showErrorMessage(data.error);
      }
    };

    React.useEffect(() => {
      const fetchSerials = async () => {
        const data = await SoftwareManagementService.getSerialNumbers();      
        setSerialNumbers(data.serials ? data.serials : []);
        
        if(data.error != null) {
          showErrorMessage(data.error);
          setSerialNumbers([]);
        } else {
          setSerialNumbers(data.serials);
        }

      };
      fetchSerials();
    },[]);

    const showErrorMessage = (message) => {
      dispatch(apiErrorSlice.actions.setErrorMessage(message))
      dispatch(apiErrorSlice.actions.setErrorType("CustomError"))
    }

    const handleDrag = (e) => {
        e.preventDefault()
        e.stopPropagation()
    }
    const handleDragIn = (e) => {
        e.preventDefault()
        e.stopPropagation()        
    }
    const handleDragOut = (e) => {
        e.preventDefault()
        e.stopPropagation()       
    }
    const handleDrop = (e) => {
        e.preventDefault()
        e.stopPropagation()

        //Don't allow more uploads while we are uploading things
        if(uploadingFile) {
          showErrorMessage("Can't upload packages while busy!")
          return
        }

        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
          setUploadingFile(true)
            SoftwareManagementService.postSoftwarePackagesToServer(e.dataTransfer.files).then((result) => {
                setUploadingFile(false)
                setWorkspace(result)
                setOpenUploadDialog(result.error == null && result.authorized)

                if(result.error) {
                  showErrorMessage(result.error);
                }
            })
            e.dataTransfer.clearData()                        
          }
    }  

    const onTargetTypeDropdownChanged = (evt) => {
        setDropDownTargetType(evt.target.value)
        setDropDownTargets([])
        setSerialFilter("")

        if (evt.target.value !== "All") {
          setTimeout(() => { document.getElementsByName("targetTypeDropDown")[0].scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"}) },200)
        }
        
        
      }

    const clearState = () => {      
        setOpenUploadDialog(false)
        setOpenTreeDialog(false)
        setPublishingWorkspace(false)
        setCopyingFiles(false)
        setWorkspace(null)        
        setDropDownTargetType("")
        setTreeNode({id:null,name:null,allowAll:false,type:""})
        setDropDownTargets([])
        setSerialFilter("")
    }

    const closeTreeDialog = () => {
      setOpenTreeDialog(false)
      setTreeNode({id:null,name:null,allowAll:false})
    }

    const cancelWorkspace = async () => {
        if(!publishingWorkspace)
        {
          const data = await SoftwareManagementService.deleteWorkspace(workspace.id);

          if(data.error != null) {
            showErrorMessage(data.error);
          }

          clearState()
        }        
      }
    
    const publishWorkspace = async () => {

        if (workspace.type === WorkspaceType.OpenVPN)
        {
          if(dropDownTargetType === "") {
            showErrorMessage("Please select a target for publishing this package");
            return
          }

          for(var i = 0; i < workspace.targets.length; i++)
          {
              workspace.targets[i] = dropDownTargetType + workspace.targets[i]
          }
        }
        else 
        {          
          if((workspace.canTargetAll &&  dropDownTargetType === "") || ( dropDownTargetType !== "All" && dropDownTargets.length === 0)) {
            showErrorMessage("Please select a target for publishing this package");
            return
          }

          if(dropDownTargetType === "All") {
            workspace.targets = ["All"]
          } else {
            workspace.targets = dropDownTargets
          }            
        }

        setPublishingWorkspace(true)

        const data = await SoftwareManagementService.publishWorkspace(workspace);        

        if(data.error != null) {
          showErrorMessage(data.error);
        }

        clearState()
        fetchData()
    }

    const moveTreeFile = async () => {
      setCopyingFiles(true)

      const data = await SoftwareManagementService.moveFileToTarget(treeNode.id,"All")
      
      if(data.error != null) {
        showErrorMessage(data.error);
      }

      clearState()
      fetchData()
    }

    const deleteTreeFile = async () => {
      const data = await SoftwareManagementService.deleteFile(treeNode.id)

      if(data.error != null) {
        showErrorMessage(data.error);
      }
      
      clearState()
      fetchData()
    }

    const getTypeString = () => {
        if (workspace == null){
            return "";
        }
        if (workspace.type === WorkspaceType.OpenVPN) {
          return "VPN Certificate";
        } else if (workspace.type === WorkspaceType.ConfigurationPackage) {
          return "Configuration";
        } else {
          return "Software Update";
        }
      }
    
    const getTargetSection = () => {
        if (workspace == null) {
            return null;
        }

        if (workspace.type === WorkspaceType.OpenVPN) {
            return (
                <>
                <br/>
                <Grid container spacing={2} sx={{border: '1px solid #4A525A',
                      borderRadius: '4px', backgroundColor:'#222E3B',paddingBottom:'15px'}}>
                {workspace.targets.map((target) => (
                  <Grid item xs={4} key={target + "key"}>
                      <Typography sx={{
                        fontFamily:'Open Sans',
                        fontSize:'18px',
                        fontWeight:'700',                        
                        letterSpacing: '0px',
                        color: '#AEB1B4'}}>&nbsp;&nbsp;&#x2022;&nbsp;&nbsp;{target}</Typography>
                  </Grid>
                ))}
                </Grid>
                <br/>
                <FormControl xs={1} sx={{ width: '100%' }} size="small">
              <InputLabel id="target-devices-label" sx={{ 
                color: theme.palette.tertiary.contrastText, 
                fontFamily:'Open Sans',
                fontSize:'16px',
                fontWeight:'600',
                letterSpacing: '0.32px' }}>Publish To: </InputLabel>
              <Select
                labelId="target-devices-label"
                value={dropDownTargetType}
                label="Publish To: "
                onChange={onTargetTypeDropdownChanged}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      backgroundColor: theme.palette.primary.main,
                      color: theme.palette.tertiary.contrastText,
                      fontFamily:'Open Sans',
                      fontSize:'16px',
                      fontWeight:'600',                      
                      letterSpacing: '0.32px'
                    },
                  },
                }}
                sx={{ 
                  color: theme.palette.tertiary.contrastText,
                  fontFamily:'Open Sans',
                  fontSize:'16px',
                  fontWeight:'600',                  
                  letterSpacing: '0.32px',
                  "& .MuiOutlinedInput-notchedOutline": {
                    color: theme.palette.tertiary.contrastText, 
                    borderColor: theme.palette.tertiary.contrastText
                  },
                  "& .Mui-focused .MuiOutlinedInput-notchedOutline": {color: theme.palette.tertiary.contrastText, borderColor: theme.palette.tertiary.contrastText},
                  "& :hover .MuiOutlinedInput-notchedOutline": {color: theme.palette.tertiary.contrastText, borderColor: theme.palette.tertiary.contrastText},
                  "& .MuiSelect-iconOutlined": {color: theme.palette.tertiary.contrastText},
                  input: { 
                    color: theme.palette.tertiary.contrastText,
                    fontFamily:'Open Sans',
                    fontSize:'16px',
                    fontWeight:'600',
                    letterSpacing: '0.32px'
                  }
                }}
              >
                <MenuItem value="HS-">Cloudport</MenuItem>
                <MenuItem value="SX-">Cloudport FBO</MenuItem>
              </Select>
            </FormControl>                
                </>
            )
        } else {
            return (
                <>                                
                <Typography sx={{
                  mx: 1, 
                  backgroundColor:'#222E3B',
                  fontFamily:'Open Sans',
                  fontSize:'18px',
                  fontWeight:'700',                  
                  letterSpacing: '0px',
                  color: '#AEB1B4',
                  border: '1px solid #4A525A',
                  borderRadius: '4px',
                  padding:'5px'
                  }}>
                 &nbsp;&nbsp;&#x2022;&nbsp;&nbsp;{workspace.data}
                </Typography>                 
                <br/>
                <FormControl xs={2} sx={{marginLeft: "auto", marginRight: "15px", width: '100%'}} size="small">
                  {workspace.canTargetAll ? (<><Grid container>
                    <Grid item>                
                      <Typography sx={{
                        mx: 1, 
                        fontFamily:'Open Sans',
                        fontSize:'18px',
                        fontWeight:'700',                        
                        letterSpacing: '0px',
                        color: '#fff',       
                        paddingTop:'5px',
                        paddingRight:'15px'           
                        }}>
                        Publish To:
                      </Typography> 
                    </Grid>
                    <Grid item>
                      <Select
                        name="targetTypeDropDown"
                        value={dropDownTargetType}                          
                        onChange={onTargetTypeDropdownChanged}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              backgroundColor: theme.palette.primary.main,
                              color: theme.palette.tertiary.contrastText,
                              fontFamily:'Open Sans',
                              fontSize:'16px',
                              fontWeight:'600',                              
                              letterSpacing: '0.32px'
                            },
                          },
                        }}
                        sx={{ 
                          color: theme.palette.tertiary.contrastText,
                          fontFamily:'Open Sans',
                          fontSize:'16px',
                          fontWeight:'600',                          
                          letterSpacing: '0.32px',
                          marginBottom: '15px',
                          "& .MuiOutlinedInput-notchedOutline": {
                            color: theme.palette.tertiary.contrastText, 
                            borderColor: theme.palette.tertiary.contrastText
                          },
                          "& .Mui-focused .MuiOutlinedInput-notchedOutline": {color: theme.palette.tertiary.contrastText, borderColor: theme.palette.tertiary.contrastText},
                          "& :hover .MuiOutlinedInput-notchedOutline": {color: theme.palette.tertiary.contrastText, borderColor: theme.palette.tertiary.contrastText},
                          "& .MuiSelect-iconOutlined": {color: theme.palette.tertiary.contrastText},
                          input: { 
                            color: theme.palette.tertiary.contrastText,
                            fontFamily:'Open Sans',
                            fontSize:'16px',
                            fontWeight:'600',                            
                            letterSpacing: '0.32px'
                          }
                        }}
                      >
                        <MenuItem value="All">All</MenuItem>
                        <MenuItem value="Devices">Specific Devices</MenuItem>
                      </Select>
                    </Grid>
                  </Grid></>) : null}                                            
                  {!workspace.canTargetAll || dropDownTargetType === "Devices" ? (<>                
                    <TextField style={{paddingBottom:'15px'}} label="Filter Devices..." variant="outlined" onChange={onFilterChanged}/>
                    <br/>
                    <Grid container spacing={2} sx={{border: '1px solid #4A525A',
                          borderRadius: '4px', backgroundColor:'#222E3B',paddingBottom:'15px'}}>
                    {serialFilter !== "" ? serialNumbers.filter(x => x.includes(serialFilter)).map((target) => (
                      <Grid item xs={4} key={target + "key"}>
                            <FormControlLabel sx={{ 
                              color: theme.palette.tertiary.contrastText,
                              fontFamily:'Open Sans',
                              fontSize:'16px',
                              fontWeight:'600',   
                              letterSpacing: '0.32px',}}
                              control={<Checkbox checked={dropDownTargets.includes(target)} onChange={e => onSerialCheckChanged(e,target)} />}
                              label={target}
                            />                    
                      </Grid>
                    )) : serialNumbers.map((target) => (
                      <Grid item xs={4} key={target + "key"}>
                            <FormControlLabel sx={{ 
                              color: theme.palette.tertiary.contrastText,
                              fontFamily:'Open Sans',
                              fontSize:'16px',
                              fontWeight:'600',   
                              letterSpacing: '0.32px',}}
                              control={<Checkbox checked={dropDownTargets.includes(target)} onChange={e => onSerialCheckChanged(e,target)} />}
                              label={target}
                            />                    
                      </Grid>
                    ))}
                    </Grid>
                    <br/>
                    </>) : null }
                  </FormControl>
                </>
            )
        }

    }

    const onFilterChanged = (e) => {
      setSerialFilter(e.target.value)
    }

    const onSerialCheckChanged = (e,device) => {
      if(e.target.checked) {
        setDropDownTargets([...dropDownTargets,device])        
      } else {
        setDropDownTargets(dropDownTargets.filter(x => x !== device))
      }
    }

    const treeActionClicked = (id,name,allowAll,type) => {
      setTreeNode({id:id,name:name,allowAll:allowAll,type:type})
      setOpenTreeDialog(true)
    }

    if(serverTree && serverTree.authorized)
    {
        return (
            <>
              <Paper
                  elevation={0}
                  className={'Software_tab'}
                  sx={{
                      p: 2,
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      backgroundColor: '#112334',
                      borderRadius: 0,
                  }}
              >
                <Box sx={{ width: '100%',top: 80, height: `calc(100vh - ${80}px)`}}>                   
                  <Box  onDragStart={handleDragIn} onDragLeave={handleDragOut} onDragOver={handleDrag} onDrop={handleDrop} style={{ 
                    backgroundColor: '#2C5877',
                    color: theme.palette.primary.contrastText,
                    position:'absolute',
                    top: '80px',
                    left: '0px',
                    width: '100%',
                    height: '120px',
                    paddingTop: '45px',
                    opacity: '1',
                    textAlign:'center',
                    verticalTextAlign:'middle',
                    fontFamily:'Open Sans',
                    fontSize:'20px',
                    fontWeight:'600' }}>                                                      
                      {uploadingFile ? (<><DragDropIcon style={{width: '44px',height: '32px',paddingRight:'7px',paddingTop:'15px'}}/><span>Uploading...</span><div><CircularProgress sx={{color:'#FFFFFF'}} style={{width: '20px',height: '20px',marginTop:'5px'}} /></div></>) : (<><DragDropIcon style={{width: '44px',height: '32px',paddingRight:'7px',paddingTop:'15px'}}/><span>Drop Files to Add New Certs, Configurations, or Software Update</span></>)}
                  </Box>
                  <Box sx={{ height: 'calc(100vh - 200px)', width: '100%', position:'fixed', top: 200, left: 0, paddingTop: '20px', paddingLeft: '30px', overflowY: 'auto'}}>
                    <Grid container spacing={2} flex={1} flexDirection={'row'}>
                      <Grid item sx={{width:'48%'}}><RemoteFileTree type={RemoteFileTreeType.Configuration} action={treeActionClicked} data={serverTree.configTree}></RemoteFileTree></Grid>
                      <Grid item sx={{width:'48%'}}><RemoteFileTree type={RemoteFileTreeType.Software} showRoot={true} action={treeActionClicked} data={serverTree.packageTree}></RemoteFileTree></Grid>
                    </Grid>
                  </Box>
                </Box>
                <Dialog
                  open={openUploadDialog}
                  onClose={cancelWorkspace}
                  PaperProps={{
                    className:'Software_tab',
                    style: {
                      backgroundColor: "#0A1826",
                      width:'800px',
                      minWidth:'800px',                    
                    },
                  }}
                  sx={{
                      p: 2,
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'column',                       
                      borderRadius: 10,                    
                  }}                    
                  aria-labelledby="alert-dialog-title"
              >
                  <DialogTitle id="alert-dialog-title" sx={{
                    color: theme.palette.primary.contrastText,
                    backgroundColor:'#2C5877',
                    fontWeight:700,
                    fontFamily:'Open Sans',
                    fontSize:'18px',                    
                    width:'100%',
                    letterSpacing: '0px'}} style={{
                      display: 'flex',
                      padding: '5px 15px',
                      justifyContent: 'space-between',
                      alignItems: 'center'}}>
                  Upload New {getTypeString()} Files <div style={{flex: '1 0 0'}} /><IconButton edge="end" onClick={cancelWorkspace}><CloseButtonIcon /></IconButton>
                  </DialogTitle>
                  <DialogContent sx={{paddingTop:'30px',paddingLeft:'85px',paddingRight:'85px'}}>
                    <br/>
                  <Typography sx={{
                    mx: 1, 
                    color: theme.palette.primary.contrastText,
                    fontWeight:700,
                    fontFamily:'Open Sans',
                    fontSize:'18px', 
                    letterSpacing: '0px'}}>
                      The following {getTypeString()} has been detected and is available to publish:
                  </Typography> 
                  <br/>
                  {getTargetSection()}
                  {publishingWorkspace ? <Backdrop id='publish-pending-backdrop' open={true}><CircularProgress sx={{color:'#FFFFFF'}} /></Backdrop> : null}                  
                  </DialogContent>
                  {publishingWorkspace ? null : (<>
                  <DialogActions sx={{paddingBottom:'30px',paddingLeft:'90px',paddingRight:'90px'}}>
                    <Button onClick={cancelWorkspace} sx={{
                      backgroundColor: '#ADADAD', 
                      color: '#626262', 
                      height:'35px',
                      width:'95px',
                      fontWeight: '600',
                      textTransform:'none',
                      fontFamily: 'Open Sans',
                      fontSize: '15px',                             
                      letterSpacing: '0.53px'}}>Cancel</Button>
                    <div style={{flex: '1 0 0'}} />
                    <Button onClick={publishWorkspace} autoFocus sx={{
                      backgroundColor: theme.palette.tertiary.main, 
                      color: theme.palette.primary.contrastText, 
                      height:'35px',
                      width:'95px',
                      fontWeight: '600',
                      fontFamily: 'Open Sans',
                      textTransform:'none',
                      fontSize: '15px',                             
                      letterSpacing: '0.53px',}}>
                        Publish
                    </Button>
                  </DialogActions></>)} 
              </Dialog>    
              <Dialog
                PaperProps={{
                  className:'Software_tab',
                    style: {
                      backgroundColor: "#0A1826",
                      width:'800px',
                      minWidth:'800px',
                    },
                  }}
                  open={openTreeDialog}
                  onClose={closeTreeDialog}
                  sx={{
                      p: 2,
                      flex: 1,
                      display: 'flex',                        
                      flexDirection: 'column',
                      borderRadius: 10,
                  }}                    
                  aria-labelledby="alert-dialog-title"
              >
                  <DialogTitle id="alert-dialog-title" sx={{
                    color: theme.palette.primary.contrastText,
                    backgroundColor:'#2C5877',
                    font: 'normal normal bold 18px/24px Open Sans',
                    letterSpacing: '0px'}} style={{
                      display: 'flex',
                      padding: '5px 15px',
                      justifyContent: 'space-between',
                      alignItems: 'center'}}>
                  Edit {treeNode.type} Files<div style={{flex: '1 0 0'}} /><IconButton edge="end" onClick={closeTreeDialog}><CloseButtonIcon /></IconButton>
                  </DialogTitle>
                  <DialogContent sx={{
                    paddingTop:'30px',
                    paddingLeft:'85px',
                    paddingRight:'85px',
                    color: theme.palette.primary.contrastText,   
                    fontWeight:700,
                    fontFamily:'Open Sans',
                    fontSize:'18px',                    
                    letterSpacing: '0px'}}>
                    <br/>
                    Please select an action for the following folder:
                    <br/>
                    <br/>
                  <Typography sx={{
                    mx: 1, 
                    font: 'normal normal bold 18px/24px Open Sans',
                    letterSpacing: '0px',
                    color: '#AEB1B4',
                    backgroundColor:'#222E3B',
                    border: '1px solid #4A525A',
                    borderRadius: '4px',
                    padding:'5px'}}>                                                
                      &nbsp;&nbsp;&#x2022;&nbsp;&nbsp;{treeNode.name}
                  </Typography>                     
                  {copyingFiles ? <Backdrop id='copying-pending-backdrop' open={true}><CircularProgress sx={{color:'#FFFFFF'}} /></Backdrop> : null}                  
                  </DialogContent>
                  {copyingFiles ? null : <DialogActions sx={{paddingBottom:'30px',paddingLeft:'90px',paddingRight:'90px'}}>
                  <Button onClick={deleteTreeFile} sx={{backgroundColor: '#D52D34', 
                    color: theme.palette.primary.contrastText, 
                    height:'35px',
                    width:'95px',
                    fontWeight: '600',
                    fontFamily: 'Open Sans',
                    fontSize: '15px',         
                    textTransform:'none',                    
                    letterSpacing: '0.53px'}}>
                      Delete
                  </Button>
                  {treeNode.allowAll ? null : (<div style={{flex: '1 0 0'}} />)}
                  <Button onClick={closeTreeDialog} autoFocus sx={{backgroundColor: '#ADADAD', 
                    color: '#626262', 
                    height:'35px',
                    width:'95px',
                    fontWeight: '600',
                    fontFamily: 'Open Sans',
                    fontSize: '15px',       
                    textTransform:'none',                      
                    letterSpacing: '0.53px'}}>Cancel</Button>                    
                  {treeNode.allowAll ? (<><div style={{flex: '1 0 0'}} /><Button onClick={moveTreeFile} sx={{
                    backgroundColor: theme.palette.tertiary.main, 
                    color: theme.palette.primary.contrastText, 
                    width: '114px',
                    height:'30px',                    
                    fontWeight: '600',
                    fontFamily: 'Open Sans',
                    fontSize: '15px',                  
                    textTransform:'none',           
                    letterSpacing: '0.53px'}}>
                      Copy to All
                  </Button></>) : null}                  
                  </DialogActions>}
              </Dialog> 
              <ErrorModal/>
            </Paper> 
            </>
          );
    } else if (serverTree) {
      return (<>
              <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="center"
                style={{ minHeight: '100vh', backgroundColor: '#112334' }}
              >
              <Stack alignItems="center" sx={{
                  width: 828,
                  boxShadow: '0px 3px 6px #00000034;',
                  borderRadius: 10,
              }}>
                  <Stack direction="row" justifyContent="center" sx={{
                      backgroundColor: '#0A1826',
                      width: '100%',
                      p: 3,
                  }}>
                      <GogoLogoIcon width={101.4585} height={47.733} />
                  </Stack>
                  <Stack direction="row" justifyContent="center" sx={{ backgroundColor: '#2C5877', width: '100%' }}>
                      <Typography
                          color="white"
                          fontSize={24}
                          textAlign="center"
                          sx={{ py: 3, px: 10 }}
                      >
                          You do not currently have access to the Software Management System
                      </Typography>
                  </Stack>
                  <Stack direction="row" justifyContent="center" sx={{ backgroundColor: '#0A1826', width: '100%' }}>
                      <Stack>
                          <Typography
                              color="white"
                              fontSize={20}
                              textAlign="center"
                              sx={{ py: 3, px: 10 }}
                          >
                              Please contact the NetOps team to request access
                          </Typography>
                      </Stack>
                  </Stack>
              </Stack>   
          </Grid> 
          <ErrorModal/>
      </>)
    }
    else
    {
       return(
        <>
         <Paper
            elevation={0}
            sx={{
                p: 2,
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: '#112334',
                borderRadius: 0,
            }}
        > No Data 
        <ErrorModal/>
        </Paper>
        </>
       );
    }
  };
  
  export default SoftwareManagement;
  